<template>
  <div>
    <textarea v-model="content" @input="updatePreview"></textarea>
    <div v-html="preview"></div>
    <button @click="saveContent">Save</button>
  </div>
</template>

<script>
import marked from 'marked';

export default {
  data() {
    return {
      content: this.page.content,
      preview: marked(this.page.content)
    };
  },
  methods: {
    updatePreview() {
      this.preview = marked(this.content);
    },
    saveContent() {
      this.$emit('save', { ...this.page, content: this.content });
    }
  }
};
</script>
